import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import TemplatesPage from "./pages/Templates";
import EditorPage from "./pages/Editor";
import Loader from "./components/common/Loader";
import { useSelector } from "react-redux";
import { ReactNotifications } from "react-notifications-component";
import { Layout } from "./layout";
import { Modal } from "./components/common/modal";
import { useDispatch } from "react-redux";
import { loadTemplateCategories } from "./thunks/dashboardThunks";
import VideoPage from "./pages/VideoPage";
import { loadVidboardAvatars } from "./thunks/editor/avatarThunks";
import ProjectPage from "./pages/ProjectPage";
import SubTitle from "./pages/SubTitle";
import AiVideoPopover from "./components/editor/AiDubbing/AiVideoPopover";
import AiDubbing from "./components/editor/AiDubbing/AIDubbing";

function App() {
  const appState = useSelector((state) => state.appState);
  const dispatch = useDispatch();
  const isMobileView =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.screen.width < 800;

  useEffect(() => {
    dispatch(loadTemplateCategories());
    dispatch(loadVidboardAvatars());
  }, [dispatch]);

  return (
    <>
      <Modal
        open={isMobileView}
        hideCancelBtn
        hideClose
        confirmText={"Okay"}
        onSubmit={() => {
          window.location.href = window.location.origin;
        }}
        center
      >
        Welcome to vidBoard.ai! For the best experience, kindly access our AI
        studio via laptop computers
      </Modal>
      <Router>
        <div className="us App">
          <ReactNotifications />
          <Routes>
            <Route
              path="/tool/dashboard"
              element={
                <Layout>
                  <Dashboard />
                </Layout>
              }
            />
            <Route
              path="/tool/templates"
              element={
                <Layout>
                  <TemplatesPage />
                </Layout>
              }
            />
            <Route
              path="/tool/projects"
              element={
                <Layout>
                  <ProjectPage />
                </Layout>
              }
            />
            <Route
              path="/tool/video"
              element={
                <Layout>
                  <VideoPage />
                </Layout>
              }
            />
            <Route
              path="/tool/editor/:type/:id"
              element={
                <Layout>
                  <EditorPage type="template" />
                </Layout>
              }
            />
            <Route
              path="/tool/subtitles/:id"
              element={
                <Layout>
                  <SubTitle />
                </Layout>
              }
            />
            <Route
              path="/tool/ai-dubbing/:id"
              element={
                <Layout>
                  <AiDubbing />
                </Layout>
              }
            />
            <Route
              path="*"
              element={<Navigate to="/tool/dashboard" replace={true} />}
            />
          </Routes>
        </div>
        {appState === "loading" && <Loader />}
      </Router>
    </>
  );
}

export default App;
// APP
